import CustomerQuote from "../../../classes/CustomerQuote.js";
import { customerScope } from "../../../util/customerScope.js";

export const GET_CUSTOMER_QUOTE = async (
  { dispatch },
  { customerID, quoteID }
) => {
  let path = CustomerQuote.getPath(customerID, quoteID);
  return dispatch("GET_DOC", {
    converter: CustomerQuote,
    path,
    stateKey: "customerInvoices",
    id: quoteID,
  });
};

export const GET_CUSTOMER_QUOTES = (
  { dispatch },
  { customerID, conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: CustomerQuote,
    stateKey: "customerInvoices",
    path: customerID ? CustomerQuote.getPath(customerID) : null,
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_CUSTOMER_QUOTE = async (
  { dispatch },
  { customerID, quoteID, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: CustomerQuote,
    path: CustomerQuote.getPath(customerID, quoteID),
    stateKey: "customerQuotes",
    id: quoteID,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_CUSTOMER_QUOTES = async (
  { dispatch, state },
  { customerID, pagination, next, error, unlisten, retain }
) => {
  return Promise.all(
    customerScope(state, customerID).map((id) =>
      dispatch("LISTEN_COLLECTION", {
        converter: CustomerQuote,
        path: CustomerQuote.getPath(id),
        stateKey: "customerQuotes",
        pagination,
        next,
        error,
        unlisten,
        retain,
      })
    )
  );
};
